import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ragioneSociale: "",
  piva: "",
};

const visureFiltersSlice = createSlice({
  name: "visureFilters",
  initialState,
  reducers: {
    setVisureFilters: (state, action) => action.payload,
    clearVisureFilters: () => null,
  },
});

export const { setVisureFilters, clearVisureFilters } =
  visureFiltersSlice.actions;
export default visureFiltersSlice.reducer;
